// extracted by mini-css-extract-plugin
export default {"reportButton":"fishing_report_link__reportButton--lrJ3"};